'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = require('ramda/src/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _templateObject = _taggedTemplateLiteral(['border-width:1px;border-style:solid;outline:none;box-sizing:border-box;transition:background-color cubic-bezier(0.47,0,0.75,0.72) 0.3s;line-height:0;cursor:', ';&:hover{background-color:', ';}&:active{background-color:', ';}background-color:', ';color:', ';border-radius:', ';width:', ';min-width:', ';height:', ';padding:', ';font-size:', ';border-color:', ';'], ['border-width:1px;border-style:solid;outline:none;box-sizing:border-box;transition:background-color cubic-bezier(0.47,0,0.75,0.72) 0.3s;line-height:0;cursor:', ';&:hover{background-color:', ';}&:active{background-color:', ';}background-color:', ';color:', ';border-radius:', ';width:', ';min-width:', ';height:', ';padding:', ';font-size:', ';border-color:', ';']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propMappers = require('./propMappers');

var propMappers = _interopRequireWildcard(_propMappers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var omitProps = (0, _omit3.default)(['block', 'kind', 'square', 'round', 'size', 'status', 'active', 'disabled']);

var BaseComponent = function BaseComponent(_ref) {
  var component = _ref.component,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ['component', 'children']);

  return _react2.default.createElement(component, omitProps(otherProps), children);
};
BaseComponent.displayName = 'BaseComponent';
BaseComponent.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired,
  children: _propTypes2.default.node // Remind: There is not a children for Input tag.
};

var Button = (0, _styledComponents2.default)(BaseComponent)(_templateObject, function (props) {
  return props.disabled ? 'not-allowed;' : 'pointer';
}, propMappers.hoverBackgroundColor, propMappers.activeBackgroundColor, propMappers.backgroundColor, propMappers.color, propMappers.borderRadius, propMappers.width, propMappers.minWidth, function (props) {
  return props.theme.height[props.size];
}, propMappers.padding, propMappers.fontSize, propMappers.borderColor);

Button.displayName = 'Button';

Button.propTypes = {
  kind: _propTypes2.default.string,
  block: _propTypes2.default.bool,
  component: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
  square: _propTypes2.default.bool,
  round: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'normal']),
  active: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool
};

Button.defaultProps = {
  kind: 'primary',
  block: false,
  component: 'button',
  square: false,
  round: false,
  size: 'normal',
  active: false,
  disabled: false
};

exports.default = Button;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/Button/Button.js
// module id = 346
// module chunks = 4